<template>
    <show-base-template v-on:edit='openEdit()' :item='item' :errors='errors' :allowedit='true' :title='title'>
        <template v-if='item.id && forms.length' v-slot:body>
            {{ forms.length }}

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.title') | capitalise }}: </div><div class="col-18"> {{item.title}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.position') | capitalise }}: </div><div class="col-18"> {{item.position}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.url') | capitalise }}: </div><div class="col-18"> {{item.url}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.form') | capitalise }}: </div><div v-if='item.form_id && Array.isArray(forms)' class="col-18"> {{forms.find(obj => {return obj.id == item.form_id}).title}}</div>
            </div>

            <div v-if='Array.isArray(feedback_forms) && feedback_forms.length > 1' class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.feedback_form') | capitalise }}: </div><div v-if='item.form_id && Array.isArray(feedback_forms)' class="col-18"> {{feedback_forms.find(obj => {return obj.id == item.feedback_form_id}).title}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.icon') | capitalise }}: </div><div class="col-18"><i :class='"pr-1 fa fa-2x fa-" + item.icon'></i></div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.tag') | capitalise }}: </div>
                <div class="col-18">
                    <div v-if='item.tag_id' class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTag(item.tag_id).colour}">
                        <i :class='"pr-1 fa fa-lg fa-" + getTag(item.tag_id).icon' /> {{ getTag(item.tag_id).name }}
                    </div>
                </div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.automatically_assign')  | capitalise }}: </div>
                <div v-if='item.assigned_user_id' class="col-18">{{ formatNameCompliant($root.lookup.staff.find(obj => {return obj.id == item.assigned_user_id})) }}</div>
                <div v-else-if='item.assigned_group_id' class="col-18">{{ $root.lookup.user_groups.find(obj => {return obj.id == item.assigned_group_id}).name }}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.autocomplete_custom_action')  | capitalise }}: </div>
                <div class="col-18">
                    {{ item.autocomplete ? "Yes" : "No"}}
                </div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.availability')  | capitalise }}: </div>
                <div class="col-18">
                    {{ availability_text() }}
                </div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.patient_availability_filter') | capitalise }}</div>
                <div class="col-18">
                    <component-filter-list :value="item.component_filter" :editable="false" />
                </div>
            </div>


        </template>
    </show-base-template>
</template>

<script>
	export default {
        extends: app.base.showBase,
        props: [
        ],

        data() {
            return {
                event: "custom_action",
                model: "custom_action",
                title: "Custom Actions",
                path: 'custom_actions',
                route: '/api/v1/custom_actions',
                allowedit: true,
                title: 'Custom Action',
                forms: [],
                feedback_forms: [],
            };
        },
        mounted() {
            var search = encodeURIComponent(JSON.stringify(
                [{
                    field: "form_type_id",
                    type: "=",
                    value: 1
                }]
            ));

            axios.get(`/api/v1/forms?p=0&search=${search}`, {}).then((res) => {
                this.forms = res.data.data;
            }).catch((error) => {
                this.handleError(error, "read");
            });

            var search = encodeURIComponent(JSON.stringify(
                [{
                    field: "form_type_id",
                    type: "=",
                    value: 2
                }]
            ));

            axios.get(`/api/v1/forms?p=0&search=${search}`, {}).then((res) => {
                this.feedback_forms = res.data.data;
            }).catch((error) => {
                this.handleError(error, "read");
            });
        },
        methods: {
            availability_text() {
                switch(this.item.allow_out_of_hours) {
                    case 0: return this.$t('translations.availability_same_as_provider');
                    case 1: return this.$t('translations.availability_always');
                    case 2: return this.$t('translations.availability_custom');
                }
            }            
        }
    };
</script>
